import PropTypes from 'prop-types';

import Input from '../Input';
import Select from '../Select';

const ELEMENT_TYPES = ['input', 'select', 'textarea'];

const renderField = (props) => {
  switch (props.element) {
    case 'select':
      return <Select {...props} />;
    case 'textarea':
      // return <Textarea {...props} />;
      return null;
    default:
      return <Input {...props} />;
  }
};

renderField.propTypes = {
  element: PropTypes.oneOf(ELEMENT_TYPES).isRequired,
};

export default renderField;
